import React from 'react';
import { useHistory } from 'react-router';
import { PermissionGroupId, PublicAmorgUser } from '../../../amorg-common';
import { getSiteUsers, impersonate } from '../../../api/adminClientApi';
import { Button } from '../../../designSystem/button/Button';
import { Flex } from '../../../designSystem/compositeComponents/FlexHelpers';
import { Modal } from '../../../designSystem/Modal';
import { ToggletipTheOne } from '../../../designSystem/ToggletipTheOne';
import { userHelper } from '../../../amorg-common/helpers/userHelper';


type ImpersonateModalButtonProps = {
    siteId: string,
    siteEnabled: boolean;
};

export function ImpersonateModalButton (props: ImpersonateModalButtonProps): JSX.Element
{
    const [show, setShow] = React.useState(false);

    const history = useHistory();

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [loading, setLoading] = React.useState(false);
    const [users, setUsers] = React.useState<PublicAmorgUser[]>([]);

    async function loadUsers()
    {
        setLoading(true);

        const permissionGroupToNumber = (id: PermissionGroupId) =>
        {
            if (id === 'superadmin') return 3;
            else if (id === 'siteadmin') return 2;
            else if (id === 'member') return 1;
            else return 0;
        }

        const sort = (lhs:PublicAmorgUser, rhs:PublicAmorgUser) => {
            return permissionGroupToNumber(rhs.permissionGroup.id) - permissionGroupToNumber(lhs.permissionGroup.id) 
                || userHelper.getPublicUserFullName(lhs).localeCompare(userHelper.getPublicUserFullName(rhs));
        }

        const users = await getSiteUsers(props.siteId, () => history.push('/amorgy/login'));
        users.sort(sort);
        const adminIndex = users.findIndex(u => u.id === 'sysadmin');
        if (adminIndex !== -1)
        {
            const adminUser = users.splice(adminIndex, 1)[0];
            users.unshift(adminUser);
        }
        setUsers(users);

        setLoading(false);
    }


    async function handleClickLaunchLogin()
    {
        await loadUsers();
        setShow(true);
    }

    function handleClickUser (email: string)
    {
        function redirect(url:string)
        {
            const win = window.open(url, '_blank');
            if (win) {
                win.focus();
            }
            setShow(false);
        }

        return async () =>
        {
            const { landingUrl } = await impersonate(props.siteId, email);
            redirect(landingUrl);
        };
    }

    function getUserIconColor (id:PermissionGroupId)
    {
        if(id === 'superadmin') return 'blue';
        else if(id === 'siteadmin') return 'darkgreen';
        else if(id === 'member') return 'lightgreen';
        else return 'darkgray';
    }

    return (
        <>
            <Button icon="login" variant='filled' text="Log ind" onClick={handleClickLaunchLogin} disabled={!props.siteEnabled} />
            <Modal
                title={"Log ind"}
                content={
                    <Flex flexDirection='column' gap={16}>
                        <Flex flexDirection='column' gap={8}>
                            {users.map(u =>
                            {
                                return (
                                    <Flex key={u.id}>
                                        <Flex style={{flexGrow:1}} gap={8} alignItems='center'>
                                            <ToggletipTheOne icon='interface_user_user' iconColor={getUserIconColor(u.permissionGroup.id)} horizontalAlignment='left'>
                                                {u.permissionGroup.name}
                                            </ToggletipTheOne>
                                            <Flex flexDirection='column' style={{flexGrow:1}}>
                                                <span style={{fontSize:'14px'}}>{userHelper.getPublicUserFullName(u)}</span>
                                                <span style={{fontSize:'12px'}}>({u.email})</span>
                                            </Flex>
                                        </Flex>
                                        <Button variant="text" icon="login" text="Log ind" onClick={handleClickUser(u.email)} />
                                    </Flex>
                                );
                            })}
                        </Flex>
                        <Flex justifyContent="flex-end">
                            <Button variant='text' text="Annullér" onClick={() => setShow(false)} />
                        </Flex>
                    </Flex>
                }
                showModal={show}
                onCancel={() => setShow(false)} />
        </>

    );
}